import React from 'react';
import { DatePickerProvider } from '../context/DatePickerContext';
import { SearchEventProvider } from '../context/SearchEventContext';
import SearchEventBar from './SearchEventBar';
import SearchEventForm from './SearchEventForm';
import EventsListing from './EventsListing';
import EventsListingHeader from './EventsListingHeader';
import { getEventDepartments, getEventTypes } from '../helpers/array-generator';
import WhatsHappeningSameMonth from './WhatsHappeningSameMonth';
import Events from '../services/Events';

export default function EventsPaginated({ dir, id }) {
  const title = dir === 'rtl' ? 'ابحث عن الفعاليات' : 'Search events here...';
  const placeholder = dir === 'rtl' ? 'ابحث عن الفعاليات...' : 'Search for events here...';

  const events = new Events();

  const data = events.get(dir === 'rtl' ? 'ar' : 'en');
  return (
    <SearchEventProvider id={id}>
      <DatePickerProvider>
        <SearchEventBar title={title} />
        <SearchEventForm
          inputTextPlaceholder={placeholder}
          selectOptions={getEventTypes(data)}
          selectOptions02={getEventDepartments(data)}
          dir={dir}
        />
        <EventsListingHeader dir={dir} />
        <EventsListing dir={dir} events={data} />
        <WhatsHappeningSameMonth dir={dir} />
      </DatePickerProvider>
    </SearchEventProvider>
  );
}
